import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BBModel } from 'bookingbug-core-js';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { AvailibilityService } from 'src/app/services/availibility.service';
import { CustomDobComponent } from 'src/app/support-components/custom-dob/custom-dob.component';
// Services
import { BasketService, DataStoreService } from '../../services';
import { CalendarComponent } from '../../support-components/calendar/calendar.component';
import { Constants } from "./application-details.abstract";


export const APP_DATE_FORMATS =
{
  parse: {
    dateInput: { month: Constants.MONTH_FORMAT, year: Constants.YEAR_FORMAT, day: Constants.DAY_FORMAT },
  },
  display: {
    dateInput: { month: Constants.MONTH_FORMAT, year: Constants.YEAR_FORMAT, day: Constants.DAY_FORMAT },
    monthYearLabel: { month: Constants.MONTH_FORMAT, year: Constants.YEAR_FORMAT }
  }
};

@Component({
  selector: 'app-application-details',
  templateUrl: './application-details.component.html',
  styleUrls: ['./application-details.component.css'],
  providers: [
    {
      provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
    }]
})

export class ApplicationDetailsComponent implements OnInit {

  // Access calendar compo's properties
  @ViewChild(CalendarComponent) calendarComponent: CalendarComponent; // Can we subscribe to events on this?s
  @ViewChild("error") errorElement: ElementRef;
  @ViewChild("completeFormError") completeFormError: ElementRef;
  @ViewChild("serviceUnavailableError") serviceUnavailableError: ElementRef;
  @ViewChild("errUnderCalendar") errUnderCalendar: ElementRef;
  @ViewChild(CustomDobComponent) customDobComponent: CustomDobComponent;


  today = new Date();
  // Set it to max 50 days (needs to be dynamic to service)
  endDate = new Date(new Date().setDate(new Date().getDate() + 50));

  dynamicForm: FormGroup;
  submitted = false;
  personQuantity = 1; // Default applicant count
  serviceList = [];
  selectedService;
  serviceTotal = 0;
  invalidSlotsAmount = false;

  // Questions
  customerQuestions = [];
  bookingQuestions;
  hovered = 1;
  // Order id = question by index
  bookingAnswers = [];

  adultFTAErr = [];
  childFTA = [];
  childFTANoCitizenship = [];
  expiredApplication = [];
  invalidAdultDOBApplication = [];
  invalidChildDOBApplication = [];
  emergencyApplication;
  onlineApplication;
  calendarReady = false;
  dateDobInvalid = false;
  availableDays;
  emptySlots: boolean;
  bornInIreland = [];
  childFTANotAvailable = [];
  unavailableService: boolean;
  confirmSelected: boolean;
  notBookable = false;
  originalDobQuestion;
  tempBasket = [];
  dateLimit: Date;
  dobErrAlreadyDisplayed = false;
  slotsInPast = false;
  alreadyPopulated = false;
  counters = [];
  slotsInvalid = false;
  nonWhitespaceRegExp: RegExp = new RegExp("\\S");
  serviceDuration;

  constructor(
    private DataStore: DataStoreService,
    private basketservice: BasketService,
    private router: Router,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public translate: TranslateService,
    private availibilityService: AvailibilityService,
    private cdref: ChangeDetectorRef,
  ) { }

  checkSlots(invalidSlot: boolean) {
    this.slotsInPast = invalidSlot;
    invalidSlot ? this.scrollToErrorUnderCalendar() : null;
  }

  // Grab the notBookable variable from the child component to check if it service is not bookable
  getBoookableCheck(bookable: boolean) {
    this.notBookable = bookable;
    this.cdref.detectChanges();
  }

  getCalendarLoadStatus(loaded: boolean) {
    this.DataStore.onNotify(loaded);
    this.cdref.detectChanges();

    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 10);
  }

  // Gets the number of slots selected everytime a slot is selected
  getSelectedSlotsLength(length: Number) {
    this.slotsInvalid = false;
    // If no slots are selected
    if (length == 0) {
      this.emptySlots = true;
      this.invalidSlotsAmount = false;
    } else if (length < this.personQuantity) {
      // slots does not equal applicant count
      this.emptySlots = false;
      this.invalidSlotsAmount = true;
    } else {
      this.emptySlots = false;
      this.invalidSlotsAmount = false;
    }
    this.cdref.detectChanges();
  }

  // Check to see if selected date in calendar is over 10 working days from today
  checkSelectedDate(onlineChannel: boolean) {
    this.onlineApplication = onlineChannel;
    if (onlineChannel) {
      this.scrollToErrorUnderCalendar();
    }
  }

  customDobCheck(event: any) {
    this.checkTriageRules(event);
  }

  conditionalQCheck(applicantIndex: any) {
    this.conditionalQuestionsQuery(applicantIndex)
  }

  questionCheck(obj: any) {
    this.onQuestionChange(obj.$event, obj.i, obj.id);
  }


  async ngOnInit() {
    this.spinner.show();
    if (this.DataStore.selectedLocation) {
      // Date to be used to check if the date selected is over 10 working days from today
      this.dateLimit = this.addWorkingDays(this.today, 9, false, false);

      const today = this.today.toISOString().split('T')[0];
      const endDate = this.endDate.toISOString().split('T')[0];

      this.dynamicForm = this.formBuilder.group({
        tickets: new FormArray([]),
        serviceControl: new FormControl('', Validators.required)
      });
      // Get the booking questions from the first service in selected department
      await this.DataStore.selectedLocation.services[0].$get(Constants.QUESTIONS).then((res) => {
        this.bookingQuestions = res.questions;
        this.DataStore.bookingQuestion = this.bookingQuestions;
      });

      // Get customer questions
      BBModel.ClientDetails.$query(this.DataStore.selectedLocation).then((details) => {
        this.customerQuestions.push(...details.questions);
      });

      // Delete any exisitng baskets to avoid conflicts
      await this.basketservice.deleteAllBaskets();

      // Delete any exisitng baskets to avoid conflicts
      if (this.basketservice.currentBasket) {
        await this.basketservice.delete(this.DataStore.selectedLocation, this.basketservice.currentBasket);
      }
      // Create a basket
      this.basketservice.currentBasket = await this.basketservice.createBasket();

      if (this.DataStore.selectedLocation.services && this.DataStore.selectedLocation.services.length > 0) {
        // Get the available days on a company
        await this.availibilityService.getAvailableDays(today, endDate);

        this.serviceList = [...this.DataStore.selectedLocation.services];

        this.updateTotal();
        this.onChangeTickets();
      } else {
        this.DataStore.onNotify(true);
      }
      // Start the applicant counter
      this.onChangeTickets();
    } else {
      // Made it a function as back btn uses it too
      this.routerGoBack();
    }
  }

  // Getters for easy access to form fields
  get formControl() { if (this.dynamicForm) { return this.dynamicForm.controls } }
  get applicantArray() { if (this.formControl) { return this.formControl.tickets as FormArray; } }

  applicantCounter(i: number) {
    return new Array(i);
  }

  // Applicant quantity change
  onChangeTickets() {
    setTimeout(() => {
      // If another applicant has been added ensure that the calendar is not ready
      if (this.personQuantity > this.tempBasket.length) {
        this.calendarReady = false;
      } else {
        this.calendarReady = true;
      }

      // If the calendar component has been initialized then recall the function getSelectedSlotsLenth
      this.calendarComponent ? this.getSelectedSlotsLength(this.calendarComponent.selectedSlots.length) : null;

      // Restore the data if the user goes back to booking details page and the back to this page
      if (this.DataStore.applicationDetails && !this.alreadyPopulated) {
        if (this.DataStore.applicationDetails.length >= 1) {
          this.personQuantity = this.DataStore.applicationDetails.length;
          this.hovered = this.DataStore.applicationDetails.length;
          this.alreadyPopulated = true;
        }
      }

      // restore previous count if coming back
      if (this.DataStore.basketItems.length >= 1) {
        this.personQuantity = this.DataStore.basketItems.length;
        this.hovered = this.DataStore.basketItems.length;
      };


      if (this.applicantArray.length < this.personQuantity) {
        for (let i = this.applicantArray.length; i < this.personQuantity; i++) {

          const application: FormGroup = this.formBuilder.group({
            // Add a new form the handle the DOB
            dobForm: new FormGroup({
              dob: new FormControl(''),
              day: new FormControl('', Validators.required),
              month: new FormControl('', Validators.required),
              year: new FormControl('', Validators.required)
            })
          });

          this.applicantArray.push(application);

          application['bookingQuestions'] = JSON.parse(JSON.stringify(this.bookingQuestions));

          for (let index = 0; index < application['bookingQuestions'].length; index++) {
            const question = application['bookingQuestions'][index];
            question.visible = false;
            question.reference = question.id;
            if (!question.admin_only) {
              if (!question.settings.hasOwnProperty(Constants.CONDITIONAL_QUESTIONS)) {
                question.visible = true;
              }

              const questionControl = question.id;

              if (question.default == 1 && question.detail_type == 'check' || question.default == 1 && question.detail_type == 'check-price') {
                if (question.required) {
                  application.addControl(questionControl, new FormControl(true, Validators.required));
                } else {
                  application.addControl(questionControl, new FormControl(true));
                }
              } else {
                if (question.required) {
                  application.addControl(questionControl, new FormControl('', [Validators.required, Validators.pattern(this.nonWhitespaceRegExp)]));
                } else {
                  application.addControl(questionControl, new FormControl(''));
                }
              }
            }
          }
        }

        // If the dynamics form exists on the datastore then this page is at a stage where data can be repopulated
        if (this.DataStore.applicationDetails) {
          this.dynamicForm = this.DataStore.dynamicForm;
          this.dynamicForm.controls.tickets = this.DataStore.applicantArray;
        }

        // Pre populate the first applicant basic details if the user has chosen to do so
        if (this.DataStore.clientDetails.applicantPresent) {
          this.applicantArray.get("0")[Constants.CONTROLS]['22'].value = this.DataStore.clientDetails.surname;
          this.applicantArray.get("0")[Constants.CONTROLS]['22'].disable();
          this.applicantArray.get("0")[Constants.CONTROLS]['23'].value = this.DataStore.clientDetails.forenameOne;
          this.applicantArray.get("0")[Constants.CONTROLS]['23'].disable();
          this.applicantArray.get("0")[Constants.CONTROLS]['24'].value = this.DataStore.clientDetails.forenameTwo;
          this.applicantArray.get("0")[Constants.CONTROLS]['24'].disable();
        } else {
          this.applicantArray.get("0")[Constants.CONTROLS]['22'].setValue(this.applicantArray.get("0")[Constants.CONTROLS]['22'].value);
          this.applicantArray.get("0")[Constants.CONTROLS]['22'].enable();
          this.applicantArray.get("0")[Constants.CONTROLS]['23'].setValue(this.applicantArray.get("0")[Constants.CONTROLS]['23'].value);
          this.applicantArray.get("0")[Constants.CONTROLS]['23'].enable();
          this.applicantArray.get("0")[Constants.CONTROLS]['24'].setValue(this.applicantArray.get("0")[Constants.CONTROLS]['24'].value);
          this.applicantArray.get("0")[Constants.CONTROLS]['24'].enable();
        }


        this.repopulateItems();
      } else {
        for (let i = this.applicantArray.length; i >= this.personQuantity; i--) {
          this.applicantArray.removeAt(i);
        }
      }
      this.spinner.hide();
      this.checkTriageRules(undefined);
      this.updateTotal();
    });
  }

  conditionalQuestionsQuery(arrayIndex) {
    const bookingQuestions = this.applicantArray.get(arrayIndex.toString())['bookingQuestions'];
    // Conditional questions logic
    for (let index = 0; index < bookingQuestions.length; index++) {
      const q = bookingQuestions[index];
      // If the question has settings and relies on a conditional question
      if (q.settings && q.settings.hasOwnProperty('conditional_question') && !q.admin_only) {
        // Get the conditional question based on the id set in q
        const conditionalQ = bookingQuestions.filter(question => question.id == q.settings.conditional_question);
        // Get the question control
        const questionControl = this.applicantArray.get(arrayIndex.toString())[Constants.CONTROLS][q.settings.conditional_question];
        // If the question control has a value get the option from the contional question. This will allow
        // us to check if q is shown when value is selected
        const option = conditionalQ[0].options.filter(option => option.name == questionControl.value);

        // If the conditional question is visible and the value chosen === to qs conditional answer then show q
        if (conditionalQ.length > 0 && conditionalQ[0].visible && option.length > 0 && q.settings.conditional_answers.hasOwnProperty(option[0].id)) {
          this.applicantArray.get(arrayIndex.toString())[Constants.CONTROLS][q.id].enable();
          // If the condiditonal question is important, Hide it
          if (q.important) {
            q.visible = false;
          } else {
            q.visible = true;
          }
        } else {
          q.visible = false;
          this.applicantArray.get(arrayIndex.toString())[Constants.CONTROLS][q.id].value = '';
          this.applicantArray.get(arrayIndex.toString())[Constants.CONTROLS][q.id].disable();
        }
      }
    }
  }

  onQuestionChange(event, arrayIndex, questionId) {
    let answer;

    if (questionId === 11) {
      this.dobErrAlreadyDisplayed = false;
    }

    const applicationValues = this.applicantArray.value[arrayIndex];

    for (let [key, value] of Object.entries(applicationValues)) {
      if (key == questionId) {
        answer = value;
      }
    }
    this.conditionalQuestionsQuery(arrayIndex);
    this.checkTriageRules(undefined);
  }

  isDate18orMoreYearsOld(day, month, year) {
    return new Date(year + 18, month, day) <= new Date();
  }

  // Check to see if the rules pass
  checkTriageRules(event) {

    // Clear all the arrays to handle updated answers for the application(s)
    this.DataStore.passportFeeArray.length = 0;
    this.childFTA.length = 0;
    this.childFTANoCitizenship.length = 0;
    this.expiredApplication.length = 0;
    this.invalidChildDOBApplication.length = 0;
    this.invalidAdultDOBApplication.length = 0;
    this.bornInIreland.length = 0;
    this.childFTANotAvailable.length = 0;
    this.adultFTAErr.length = 0;

    const applications = this.applicantArray.controls;

    for (let index = 0; index < applications.length; index++) {
      const application = applications[index];
      // Get the Date of birth

      let dobIncorrectChecks = [];
      let dateOfBirth;
      // year || month || day
      if (application[Constants.CONTROLS].dobForm.controls.day.value === '' || application[Constants.CONTROLS].dobForm.controls.month.value === '' || application[Constants.CONTROLS].dobForm.controls.year.value === '') {
        application[Constants.CONTROLS].dobForm.controls.dob.setErrors({ 'required': true });
      } else {
        // Is the year valid
        if (application[Constants.CONTROLS].dobForm.controls.year.value.length <= 3) {
          dobIncorrectChecks.push(application[Constants.CONTROLS].dobForm.controls.dob);
        } else {
          if (Number(application[Constants.CONTROLS].dobForm.controls.year.value) < 1900 || Number(application[Constants.CONTROLS].dobForm.controls.year.value) > new Date().getFullYear()) {
            dobIncorrectChecks.push(application[Constants.CONTROLS].dobForm.controls.dob);
          }
        }

        // Is the month valid
        if (moment([application[Constants.CONTROLS].dobForm.controls.year.value, application[Constants.CONTROLS].dobForm.controls.month.value]).isAfter()) {
          dobIncorrectChecks.push(application[Constants.CONTROLS].dobForm.controls.dob);
        } else {
          application[Constants.CONTROLS].dobForm.controls.dob.setErrors(null);
        }

        // Is the day input valid for the month
        const daysInSelectedMonth = moment([application[Constants.CONTROLS].dobForm.controls.year.value, application[Constants.CONTROLS].dobForm.controls.month.value]).daysInMonth();
        if (Number(application[Constants.CONTROLS].dobForm.controls.day.value) >= 1) {
          if (Number(application[Constants.CONTROLS].dobForm.controls.day.value) > daysInSelectedMonth) {
            dobIncorrectChecks.push(application[Constants.CONTROLS].dobForm.controls.dob);
          }
        } else {
          dobIncorrectChecks.push(application[Constants.CONTROLS].dobForm.controls.dob);
        }

        // check if whole date is not in the future
        if (moment([application[Constants.CONTROLS].dobForm.controls.year.value, application[Constants.CONTROLS].dobForm.controls.month.value, application[Constants.CONTROLS].dobForm.controls.day.value]).isAfter(new Date().toISOString().split('T')[0])) {
          dobIncorrectChecks.push(application[Constants.CONTROLS].dobForm.controls.dob);
        }
      }

      if (dobIncorrectChecks.length > 0) {
        application[Constants.CONTROLS].dobForm.controls.dob.setErrors({ 'incorrect': true });
        this.cdref.detectChanges();
      }


      dateOfBirth = new Date(application[Constants.CONTROLS].dobForm.controls.year.value, application[Constants.CONTROLS].dobForm.controls.month.value, application[Constants.CONTROLS].dobForm.controls.day.value);
      // Needed to resolve the Daylight saving time issue
      dateOfBirth.setTime(dateOfBirth.getTime() - new Date().getTimezoneOffset() * 60 * 1000);

      this.cdref.detectChanges();

      // Get the application type chosen
      const applicationType = application.value['11'].trim();
      const applicationTypeQuestion = this.bookingQuestions.filter(question => question.id == 11);
      const applicationTypeOption = applicationTypeQuestion[0].options.filter(option => option.name == applicationType);

      // Get the within 15 years answer
      const within15Years = application.value['12'];
      const within15YearsQuestion = this.bookingQuestions.filter(question => question.id == 12);
      const within15YearsOption = within15YearsQuestion[0].options.filter(option => option.name == within15Years);

      // Get the citizenship answer
      const citizenship = application.value['21'];
      const citizenshipQuestion = this.bookingQuestions.filter(question => question.id == 21);
      const citizenshipOption = citizenshipQuestion.length > 0 ? citizenshipQuestion[0].options.filter(option => option.name == citizenship) : '';

      // Get the born in Ireland answer
      const bornIreland = application.value['20'];
      const bornIrelandQuestion = this.bookingQuestions.filter(question => question.id == 20);
      const bornIrelandOption = bornIrelandQuestion.length > 0 ? bornIrelandQuestion[0].options.filter(option => option.name == bornIreland) : '';

      if (typeof dateOfBirth !== 'object') {
        dateOfBirth = new Date(dateOfBirth);
      }

      // If DOB has data then check if the DOB is equal or greater than 18 years old else return false
      const dobValid = dateOfBirth ? this.isDate18orMoreYearsOld(dateOfBirth.getDate(), dateOfBirth.getMonth(), dateOfBirth.getFullYear()) : true;
      // Check if the date of birth has been completed
      let dobComplete = false;
      if (this.customDobComponent) {
        if (application[Constants.CONTROLS].dobForm.controls.day.value.length > 0 && application[Constants.CONTROLS].dobForm.controls.month.value.toString().length > 0 && application[Constants.CONTROLS].dobForm.controls.year.value.length === 4) {
          dobComplete = true;
          // SUP-157 - DOB rolling back, the old "toISOString" code ignores timezone fix
          var isoDateTime = new Date(dateOfBirth.getTime() - (dateOfBirth.getTimezoneOffset() * 60000)).toISOString();
          application[Constants.CONTROLS]['25'].setValue(isoDateTime);
        }
      }

      // Adult Renewal Application
      if (applicationTypeOption.length > 0 && applicationTypeOption[0].name == Constants.ADULT_RENEWAL_APPLICATION) {
        // If date of birth is not > 18 years old then set invalidDOBApplication to true else false
        if (!dobValid) {
          this.invalidAdultDOBApplication.push(application);
          application[Constants.CONTROLS]['11'].setErrors({ 'incorrect': true })
          application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].disable() : null;
          // scroll to the error message below the view
          application[Constants.CONTROLS]['12'].disable();
          this.scrollToError();
        } else {
          application[Constants.CONTROLS]['11'].setErrors(null);
          application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].enable() : null;
          application[Constants.CONTROLS]['12'].enable();
        }

        // If it is an expired application then set expiredApplication to true else false
        if (within15YearsOption.length > 0 && within15YearsOption[0].id == Constants.NO_15_YEARS) {
          this.expiredApplication.push(application);
          application[Constants.CONTROLS]['12'].setErrors({ 'incorrect': true });
          application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].disable() : null;
          // scroll to the error message below the view
          this.scrollToError();
        } else {
          application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].enable() : null;
        }

        // If it is the adult application add the adult application fee
        this.bookingQuestions.forEach(question => {
          if (question.id == 16) {
            this.DataStore.passportFeeArray.push(question);
          }
        });

        if (this.invalidAdultDOBApplication.length > 0) {
          application[Constants.CONTROLS][10].disable();
          application[Constants.CONTROLS][12].disable();
          // scroll to the error message below the view
          this.dobErrAlreadyDisplayed ? null : this.scrollToError();
          this.dobErrAlreadyDisplayed = true;
        }
      }

      // Child Renewal Application
      if (applicationTypeOption.length > 0 && applicationTypeOption[0].name == Constants.CHILD_RENEWAL_APPLICATION) {
        // If date of birth is not <= 18 years old then set invalidDOBApplication to true else false
        if (dobValid && dobComplete) {
          this.invalidChildDOBApplication.push(application);
          application[Constants.CONTROLS]['11'].setErrors({ 'incorrect': true });
          application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].disable() : null;
          application[Constants.CONTROLS]['12'].disable();
          // scroll to the error message below the view
          this.dobErrAlreadyDisplayed ? null : this.scrollToError();
          this.dobErrAlreadyDisplayed = true;
        } else {
          application[Constants.CONTROLS]['11'].setErrors(null);
          application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].enable() : null;
          application[Constants.CONTROLS]['12'].enable();
        }


        if (within15YearsOption.length > 0 && within15YearsOption[0].id == Constants.NO_15_YEARS) {
          this.expiredApplication.push(application);
          application[Constants.CONTROLS]['12'].setErrors({ 'incorrect': true });
          application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].disable() : null;
          // scroll to the error message below the view
          this.scrollToError();
        }

        // If it is the adult application add the child application fee
        this.bookingQuestions.forEach(question => {
          if (question.id == 15) {
            this.DataStore.passportFeeArray.push(question);
          }
        });
      }

      // Child First Time Application
      if (applicationTypeOption.length > 0 && applicationTypeOption[0].name == Constants.CHILD_FIRST_TIME_APPLICATION) {
        // If date of birth is not <= 18 years old then set invalidDOBApplication to true else false
        if (dobValid && dobComplete) {
          this.invalidChildDOBApplication.push(application);
          application[Constants.CONTROLS]['11'].setErrors({ 'incorrect': true });
          application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].disable() : null;
          application[Constants.CONTROLS]['20'].disable();
          // scroll to the error message below the view
          this.dobErrAlreadyDisplayed ? null : this.scrollToError();
          this.dobErrAlreadyDisplayed = true;
        } else {
          application[Constants.CONTROLS]['11'].setErrors(null);
        }
        if (citizenshipOption.length > 0 && citizenshipOption[0].id == Constants.NO_CITIZENSHIP) {
          this.childFTANoCitizenship.push(application);
          application[Constants.CONTROLS]['11'].setErrors({ 'incorrect': true })
          application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].disable() : null;
          // scroll to the error message below the view
          this.scrollToError();
        }

        var cutOffDate = new Date("December 31, 2004 00:00:00");
        if (bornIrelandOption.length > 0 && bornIrelandOption[0].id == Constants.YES_BORN_IN_IRELAND && dateOfBirth > cutOffDate) {
          this.bornInIreland.push(application);
          application[Constants.CONTROLS].dobForm.controls.dob.setErrors({ 'incorrect': true });
          application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].disable() : null
          this.cdref.detectChanges();
          // scroll to the error message below the view
          this.scrollToError();
        }

        this.invalidChildDOBApplication.length == 0 && this.childFTA.length == 0 && this.bornInIreland.length == 0 ? application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].enable() : null : null;

        // If it is the adult application add the child application fee
        this.bookingQuestions.forEach(question => {
          if (question.id == 15) {
            this.DataStore.passportFeeArray.push(question);
          }
        });
        if (this.dynamicForm.value.serviceControl && this.dynamicForm.value.serviceControl.name && this.dynamicForm.value.serviceControl.name.includes('Same-Day')) {
          this.childFTANotAvailable.push(application);
        }
      }

      // Adult First Time Application
      if (applicationTypeOption.length > 0 && applicationTypeOption[0].name == Constants.ADULT_FIRST_TIME_APPLICATION) {
        this.adultFTAErr.push(application);
        application[Constants.CONTROLS]['11'].setErrors({ 'incorrect': true })
        application[Constants.CONTROLS]['10'] ? application[Constants.CONTROLS]['10'].disable() : null;
        // scroll to the error message below the view
        this.dobErrAlreadyDisplayed ? null : this.scrollToError();
        this.dobErrAlreadyDisplayed = true;
      }
    }

    if (this.childFTANotAvailable.length == 0) {
      this.unavailableService = false;
    } else {
      this.unavailableService = true;
      // scroll to the error message below the view
      this.applicantArray.valid ? this.scrollToServiceUnavailableError() : null;
    }
    this.cdref.detectChanges();
  }

  // scroll to the first invalid control on page
  scrollToError() {
    this.errorElement.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  // scroll to the please complete form error
  scrollToFormValidationError() {
    this.completeFormError.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  // scroll to the services error
  scrollToServiceUnavailableError() {
    this.serviceUnavailableError.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  // scroll to the error messages under calendar
  scrollToErrorUnderCalendar() {
    this.errUnderCalendar.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  // submit button for entire page
  proceed() {
    this.dynamicForm.markAllAsTouched(); // This line saved our lives, Marks all forms as clicked on for validation
    this.submitted = true;

    // Get the service type
    const serviceType = this.dynamicForm.value.serviceControl;

    // stop here if form is invalid
    if (this.dynamicForm.invalid) {
      // scroll to the invalid error on page
      this.scrollToFormValidationError();
      return;
    }

    if (serviceType.name.includes('Emergency')) {
      this.emergencyApplication = true;
      this.dynamicForm.controls.serviceControl.setErrors({ 'incorrect': true });
      this.scrollToErrorUnderCalendar();
    } else {
      this.emergencyApplication = false;
      this.dynamicForm.controls.serviceControl.setErrors(null);
      // Check all the rules
      this.checkTriageRules(undefined)
    }

    // Store the applications on the store
    this.DataStore.applicationDetails = this.dynamicForm.controls.tickets;
    // Store the service on the store
    this.DataStore.service = this.dynamicForm.value.serviceControl;

    // Display the calendar
    this.calendarReady = true;

    // Store the applicantArray on the datastore
    this.DataStore.applicantArray = this.applicantArray;
    // Store the chose service on the datastore
    this.DataStore.dynamicForm = this.dynamicForm;

    // focus calendar for accessiblity
    var element = document.getElementById('cal-container');
    if (element) {
      if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
        element.tabIndex = -1;
      }
      element.focus();
    }
  }

  addWorkingDays(datStartDate, lngNumberOfWorkingDays, blnIncSat, blnIncSun) {
    var intWorkingDays = 5;
    var intNonWorkingDays = 2;
    var intStartDay = datStartDate.getDay(); // 0=Sunday ... 6=Saturday
    var intOffset;
    var intModifier = 0;

    if (blnIncSat) { intWorkingDays++; intNonWorkingDays--; }
    if (blnIncSun) { intWorkingDays++; intNonWorkingDays--; }
    var newDate = new Date(datStartDate)
    if (lngNumberOfWorkingDays >= 0) {
      // Moving Forward
      if (!blnIncSat && blnIncSun) {
        intOffset = intStartDay;
      } else {
        intOffset = intStartDay - 1;
      }
      // Special start Saturday rule for 5 day week
      if (intStartDay == 6 && !blnIncSat && !blnIncSun) {
        intOffset -= 6;
        intModifier = 1;
      }
    } else {
      // Moving Backward
      if (blnIncSat && !blnIncSun) {
        intOffset = intStartDay - 6;
      } else {
        intOffset = intStartDay - 5;
      }
      // Special start Sunday rule for 5 day week
      if (intStartDay == 0 && !blnIncSat && !blnIncSun) {
        intOffset++;
        intModifier = 1;
      }
    }
    // ~~ is used to achieve integer division for both positive and negative numbers
    newDate.setTime(datStartDate.getTime() + (new Number(((lngNumberOfWorkingDays + intOffset) / intWorkingDays) * intNonWorkingDays) + lngNumberOfWorkingDays + intModifier) * 86400000);
    return newDate;
  }

  async confirm() {
    this.spinner.show();

    // Delete any exisitng baskets to avoid conflicts
    await this.basketservice.deleteAllBaskets();

    // Delete any exisitng baskets to avoid conflicts
    if (this.basketservice.currentBasket) {
      await this.basketservice.delete(this.DataStore.selectedLocation, this.basketservice.currentBasket);
    }
    // Create a basket
    this.basketservice.currentBasket = await this.basketservice.createBasket();

    this.confirmSelected = true;

    // Check if the users selected slots are still valid (not in the past). If the selected slot is 
    // now in the past then display error message and stop them from proceeding
    this.calendarComponent.selectedSlots.forEach(slot => {
      const now = new Date();
      const selectedStart = new Date(slot.start);
      if (now >= selectedStart) {
        this.checkSlots(true);
      }
    });

    // Check if the selected slots are stil valid
    let invalidSlots = 0;
    if (this.calendarComponent.selectedSlots.length === this.applicantArray.length) {
      for (let index = 0; index < this.DataStore.applicationDetails.value.length; index++) {
        const slotResponse = await this.availibilityService.getTimes(this.dynamicForm.value.serviceControl.id, this.calendarComponent.selectedSlots[index].start);
        if (!slotResponse['available']) {
          invalidSlots++;
          this.calendarComponent.selectedSlots[index].available = false;
          this.slotsInPast ? null : this.slotsInvalid = true;
          this.spinner.hide();
        }
      }
    }

    // If the user has not selected any slots or they have not selected
    // the right amount of slots then stop them from proceeding
    if (this.emptySlots || this.invalidSlotsAmount || this.slotsInPast || invalidSlots > 0) {
      this.scrollToErrorUnderCalendar();

      // Only clear slots if has invalid slots selected
      invalidSlots > 0 ? this.calendarComponent.selectedSlots.length = 0 : null;
      this.spinner.hide();
      return;
    } else {
      /* Select same counter logic */
      if (this.applicantArray.length > 1) {
        let counterId;
        let availabilityFound = false;
        for (let index = 0; index < this.DataStore.counters.length; index++) {
          const counter = this.DataStore.counters[index];
          let itemBookable = false;
          const items = await counter.$getItems();

          items.forEach(async item => {
            if (item.type === 'service' && item.service_item_id === this.dynamicForm.value.serviceControl.id) {
              itemBookable = true;
            }
          });

          if (itemBookable) {
            const params = {
              'company_id': this.DataStore.selectedLocation.id,
              'service_id': this.DataStore.selectedService.id,
              'start_date': this.calendarComponent.selectedSlots[0].start.split('T')[0],
              'end_date': this.calendarComponent.selectedSlots[0].start.split('T')[0],
              'resource_id': counter.id
            };

            const baseResource = await this.DataStore.selectedLocation.$get('times', params)
            const slots = await baseResource.times;

            // Filter the availability based on the selected slots
            const availibility = [];
            slots.forEach(slot => {
              this.calendarComponent.selectedSlots.forEach(selectedSlot => {
                if (slot.start === selectedSlot.start && slot.available) {
                  availibility.push(slot);
                }
              });
            });

            if (availibility.length === this.applicantArray.length) {
              counterId = counter.id;
              // Add the items to the existing basket with specified person to book
              this.addItem(counterId);
              availabilityFound = true;
              return;
            }
          }
        }
        if (!availabilityFound) {
          this.addItem(null);
        }
      } else {
        // Add the items to the existing basket
        this.addItem(null);
      }
    }
  }

  // Remove the application
  removeApplication(index) {
    // Get the array of applications
    const applications = this.applicantArray.controls;
    // Remove the application at the specified index
    applications.splice(index, 1);
    this.checkTriageRules(undefined);
    // Update the total service price after removing applicants
    if (this.dynamicForm.value.serviceControl) {
      this.DataStore.serviceTotal = this.applicantArray.length * this.dynamicForm.controls.serviceControl.value.price;
    }
    this.personQuantity = applications.length;
    // Update the number in the bubble
    this.hovered = applications.length;
    // Reset service control option if removed all applicants
    if (this.applicantArray.controls.length === 0) {
      this.dynamicForm.controls.serviceControl.setValue(null);
      this.calendarReady = false;
      this.tempBasket.length = 0;
    }

    if (index === 0) {
      this.DataStore.clientDetails.applicantPresent = false;
    }
  }

  // Go back to the booking details page
  routerGoBack() {
    this.router.navigate(['/booking-details']);
  }

  // When the service is changed in the drop down update the service on the store and update the total price
  async updateTotal() {
    this.emergencyApplication = false;
    this.submitted = false;
    this.dynamicForm.controls.serviceControl.setErrors(null);

    this.DataStore.selectedService = this.dynamicForm.controls.serviceControl.value;

    if (this.dynamicForm.value.serviceControl) {
      this.DataStore.serviceTotal = this.applicantArray.length * this.dynamicForm.controls.serviceControl.value.price;
    }

    if (this.dynamicForm.value.serviceControl && this.dynamicForm.value.serviceControl.name) {
      // Check if the service selected is the emergency service
      if (this.dynamicForm.value.serviceControl.name.includes('Emergency')) {
        this.emergencyApplication = true;
        this.scrollToErrorUnderCalendar();
      }
      // Check if the service selected is the same day service
      if (this.dynamicForm.value.serviceControl.name.includes('Same-Day')) {
        this.checkTriageRules(undefined);
        if (this.childFTANotAvailable.length > 0) {
          this.unavailableService = true;
          // scroll to the error message below the view
          this.scrollToServiceUnavailableError();
        }
      } else {
        this.unavailableService = false;
      }
    }
    this.cdref.detectChanges();

    if (this.calendarComponent) {
      this.dynamicForm.markAllAsTouched();
      if (this.dynamicForm.value.serviceControl.name.includes('Emergency')) {
        this.calendarReady = false;
        this.emergencyApplication = true;
        this.dynamicForm.controls.serviceControl.setErrors({ 'incorrect': true });
        this.scrollToErrorUnderCalendar();
      } else {
        this.calendarComponent.selectedSlots.length = 0;
        this.calendarComponent.slotsLength.emit(this.calendarComponent.selectedSlots.length);
        this.calendarReady = false;
        this.proceed();
      }
    }
  }

  // Add the item the basket
  async addItem(counterId) {
    let basketBroken = false;
    for (let index = 0; index < this.DataStore.applicationDetails.value.length; index++) {
      const applicant = this.DataStore.applicationDetails.value[index];
      // Clean array everytime
      this.bookingAnswers.length = 0;

      // Loop through all the bookings and only add booking answers that exist in the question array
      for (var key in applicant) {
        if (applicant.hasOwnProperty(key)) {
          const question = this.bookingQuestions.filter(question => question.id == key);
          if (question.length > 0) {
            if (key === '15' || key === '16') {
              this.bookingAnswers.push({ id: key, answer: 1 });
            } else {
              this.bookingAnswers.push({ id: key, answer: applicant[key] });
            }
          }
        }
      }

      if (index == 0 && this.DataStore.clientDetails.applicantPresent) {
        // Push the surname Q
        this.bookingAnswers.push({ id: '22', answer: this.DataStore.clientDetails.surname })
        // Push the forename 1 Q
        this.bookingAnswers.push({ id: '23', answer: this.DataStore.clientDetails.forenameOne })
        // Push the forename 2 Q
        if (this.DataStore.clientDetails.forenameTwo) {
          this.bookingAnswers.push({ id: '24', answer: this.DataStore.clientDetails.forenameTwo })
        }
      }

      // Is the booking in irish, Auto populate this question
      const usingIrish = this.translate.currentLang == "ie" ? 'Yes | Tá' : 'No | Níl';
      this.bookingAnswers.push({ id: 6, answer: usingIrish })

      // Add the item, This requires;
      // service id, duration, start time and the questions
      if (!counterId) {
        counterId = this.calendarComponent.selectedSlots[index].resource_id;
      }

      // only one service duration is selectable in jrni at this time (22/09/21) but it comes through as an array
      this.serviceDuration = this.DataStore.selectedService.durations[0];

      // First attempt at adding item to basket
      const res = await this.basketservice.addItem(this.DataStore.selectedService.id, this.serviceDuration, this.calendarComponent.selectedSlots[index].start, this.bookingAnswers, counterId);
      if (res['response']) {
        // If conflict
        if (res['response'].status === 409) {
          this.slotsInvalid = true;
          this.calendarComponent.selectedSlots[index].available = false;
          // If basket has not been created
        } else if (res['response'].status === 404) {
          // Delete any exisitng baskets to avoid conflicts
          await this.basketservice.deleteAllBaskets();

          // Delete any exisitng baskets to avoid conflicts
          if (this.basketservice.currentBasket) {
            await this.basketservice.delete(this.DataStore.selectedLocation, this.basketservice.currentBasket);
          }
          // Create a basket
          this.basketservice.currentBasket = await this.basketservice.createBasket();

          // Second attempt to add item to basket
          const secondRes = await this.basketservice.addItem(this.DataStore.selectedService.id, this.serviceDuration, this.calendarComponent.selectedSlots[index].start, this.bookingAnswers, counterId);
          if (secondRes['response']) {
            // If conflict
            if (secondRes['response'].status === 409) {
              this.slotsInvalid = true;
              this.calendarComponent.selectedSlots[index].available = false;
              // If basket does not exists again show load issue
            } else if (secondRes['response'].status === 404) {
              basketBroken = true;
            }
          }
        }
      }
    }
    if (this.slotsInvalid) {
      this.calendarComponent.selectedSlots.length = 0;
    } else if (basketBroken) {
      this.DataStore.onNotify(true);
      const scrollToTop = window.setInterval(() => {
        const pos = window.pageYOffset;
        if (pos > 0) {
          window.scrollTo(0, pos - 20);
        } else {
          window.clearInterval(scrollToTop);
        }
      }, 10);
    } else {
      this.DataStore.applicantArrayCopy = this.applicantArray;
      // Navigate to the checklist page
      this.router.navigate(['/checklist']);
    }
    this.spinner.hide();
  }

  // dob input text validation
  keyPressDobField(event: any, i) {
    const pattern = /^[0-9]{1,45}$/;
    if (event.keyCode != 8 && event.keyCode != 9 &&
      event.keyCode != 40 && event.keyCode != 38 && !pattern.test(event.key)) {
      event.preventDefault();
    }
    this.conditionalQuestionsQuery(i)
    this.checkTriageRules(event);
  }

  // Repopulate the applicant details and the service if the user has come back from checklist
  repopulateItems() {
    this.tempBasket = this.DataStore.basketItems;
    this.DataStore.basketItems = [];
    // If the user has come back, repopulate previous data
    if (this.tempBasket.length >= 1) {
      this.tempBasket.forEach((basket, basketIndex) => {
        // Repopulate the questions
        basket.questions.forEach(question => {
          let questionHolder = {};
          questionHolder[question.id] = question.answer;

          // date of birth
          if (question.id == 25) {
            const tempDate = question.answer.split('T')[0].split('-');
            if (this.customDobComponent) {
              this.applicantArray.controls[basketIndex][Constants.CONTROLS].dobForm.controls.day.setValue(tempDate[2]);
              this.applicantArray.controls[basketIndex][Constants.CONTROLS].dobForm.controls.month.setValue(Number(tempDate[1] - 1));
              this.applicantArray.controls[basketIndex][Constants.CONTROLS].dobForm.controls.year.setValue(tempDate[0]);
            }
          } else {
            this.applicantArray.controls[basketIndex].patchValue(questionHolder);
          }

        });
        this.conditionalQuestionsQuery(basketIndex);

        // Repopulate the service
        const selectedService = this.serviceList.filter(service => service.id === basket.service_id);
        this.dynamicForm.controls.serviceControl.setValue(selectedService[0]);
      });
      this.calendarReady = true;

      this.cdref.detectChanges();
    }
  }
}